/* istanbul ignore file */
import { DevTestIntegrationInit } from 'components/DevTest';
import { WelcomeModalProvider } from 'components/Modal/WelcomeModalContext';
import { Routes } from 'routes';
import { FeatureProvider, StoreProvider } from 'store/configureStore';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from 'styles/globalStyles';
import theme from 'styles/theme';
import GlobalToolbarIntegrationInit from '../../toolbar/GlobalToolbarIntegrationInit';

function App() {
  return (
    <StoreProvider>
      <FeatureProvider>
        <WelcomeModalProvider>
          <GlobalToolbarIntegrationInit />
          <DevTestIntegrationInit />
          <ThemeProvider theme={theme}>
            <GlobalStyle />
            <Routes />
          </ThemeProvider>
        </WelcomeModalProvider>
      </FeatureProvider>
    </StoreProvider>
  );
}

export default App;
